import { Pipe, PipeTransform } from '@angular/core';

/** Obtain the arguments' types of a function except the first argument */
export type RestArgument<T> = T extends (first: any, ...args: infer Rest) => any
    ? Rest
    : [];


@Pipe({
    name: 'apply',
    standalone: true,
})
export class ApplyFunctionPipe implements PipeTransform {
  /**
   * @param callbackMethod method of arrow-function that is to be run using `ApplyFunctionPipe`.
   ** please pass an arrow function instead of regular class method
   **/
     transform<Callback extends (value: any, ...extra: any[]) => any>(
        value: Parameters<Callback>[0],
        callbackMethod: Callback,
        ...extra: RestArgument<Callback>
    ): ReturnType<Callback> {
        return callbackMethod(value, ...extra);
    }
}
